var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" All package types: "),_c('span',{staticClass:"footer-links"},[_c('LinkList',{attrs:{"items":_vm.items}})],1),_c('p',{staticClass:"pt-3 pb-5"},[_vm._v("Postage prices can change at any time, so we take no responsibility for outdated information. Please check the Royal Mail website for the latest information.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }